import { render, staticRenderFns } from "./ProfitAmountsPerResource.vue?vue&type=template&id=6bd52c4c&"
import script from "./ProfitAmountsPerResource.vue?vue&type=script&lang=js&"
export * from "./ProfitAmountsPerResource.vue?vue&type=script&lang=js&"
import style0 from "./ProfitAmountsPerResource.vue?vue&type=style&index=0&id=6bd52c4c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports